<script setup lang="ts">
const paginationContext = usePaginationContext();
const theme = usePaginationTheme();
const { isDesktop } = useLayout();

type Props = {
  selectOnly?: boolean;
};

withDefaults(defineProps<Props>(), {
  selectOnly: false
});

function setPageSize(size: number) {
  paginationContext.setPageSize(size);
}

const selectedSize = ref(paginationContext.currentPageSize.value);

watch(selectedSize, (newSize) => {
  setPageSize(newSize);
});
</script>

<template>
  <div :class="theme.pageSize.wrapper()">
    <slot>
      <slot name="buttons">
        <template v-if="isDesktop || selectOnly">
          <span
            aria-hidden="true"
            :class="theme.pageSize.sizeDescription()"
          >
            {{ $t('Pagination.Aria.ItemsPerPage', { type: paginationContext.itemTypePlural.value }) }}:
          </span>
          <PaginationPageSizeButtons />
        </template>
      </slot>
      <slot name="select">
        <PaginationPageSizeSelect v-if="selectOnly || !isDesktop" />
      </slot>
    </slot>
  </div>
</template>
